<script setup lang="ts">
import { NotificationConnectionVariantEnum } from "./enums";
import { PropType, ref } from "vue";
import {
  NotificationConnected,
  NotificationDisconnected,
  NotificationReconnected,
} from "./components";

/**Параметры */
const props = defineProps({
  variant: { type: String as PropType<NotificationConnectionVariantEnum> },
});
/**События */
const emit = defineEmits<{
  /**Событие закрытия уведомления */
  closeNotification: [];
  /**Событие переподключения */
  reconnect: [];
}>();

/**Получение компонента в зависимости от состояния соединения */
const getConnectionComponent = () => {
  switch (props.variant) {
    case NotificationConnectionVariantEnum.Disconnected:
      return NotificationDisconnected;
    case NotificationConnectionVariantEnum.Connected:
      return NotificationConnected;
    case NotificationConnectionVariantEnum.Reconnected:
      return NotificationReconnected;
  }
};
</script>

<template>
  <component
    :is="getConnectionComponent()"
    @closeNotification="emit('closeNotification')"
    @reconnect="emit('reconnect')"
  />
</template>
